import r from "./design-system.es871.js";
import t from "./design-system.es872.js";
function m() {
  return r(t, arguments);
}
export {
  m as parsePhoneNumberWithError
};
//# sourceMappingURL=design-system.es309.js.map
